import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { installAuthErrorHandler, type AuthErrorHandlerOptions } from './install-auth-error-handler';

export function AuthErrorHandler({ isAuthError, onAuthError }: AuthErrorHandlerOptions) {
  const queryClient = useQueryClient();
  useEffect(() => {
    return installAuthErrorHandler(queryClient, { isAuthError, onAuthError });
  }, [queryClient, isAuthError, onAuthError]);
  return null;
}
